import { environment } from "src/environments/environment";

export abstract class Configuration {
    public static getApiBaseUrl(): string {
        return this.getBaseUrl() + '/api';
    }

    public static getBaseUrl(): string {
        if (window.location.hostname.toLowerCase().includes('localhost') || window.location.hostname.includes('127.0.0.1')) {
            return "https://localhost:7075";
        }
        return "https://" + window.location.host;
    }

    public static getMainDomain(): string {
        return `https://${environment.defaultTenant}.${environment.rootDomain}`;
    }

    public static getIntegrationRedirectUrl(integration: string): string {
        return `${Configuration.getMainDomain()}/integrations/${integration}/oauth`;
    }
}
